<template>
  <form-select
    class="field-select"
    v-model="val"
    :options="options"
    v-bind="$attrs"
    v-on="$listeners"
    @change="valchange"
    clearable
  ></form-select>
</template>
<script>
var name = 'field-select'
export default {
  name,
  props: {
    fieldIndex: Number,
    category: String,
    value: String,
    field: String,
    packid: String,
    version: String,
    lang: String,
    //brand: String,
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
    select() {
      return this.$refs.select
    },
  },
  data() {
    return {
      name,
      options: [],
    }
  },
  // created() {
  //   //this.getFieldOptions()
  //   this.$eventBus.$on('searchDataChange', this.searchDataChange)
  // },
  // destroyed() {
  //   this.$eventBus.$off('searchDataChange', this.searchDataChange)
  // },
  methods: {
    getFieldOptions(searchData) {
      var data = Object.assign({}, searchData, {
        category: this.category,
        field: this.field,
        lang: this.lang,
        packid: this.packid,
        version: this.version,
        //brand: this.brand,
      })
      data[this.field] = null
      this.$post('view/getFieldOptions', data)
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            var options = []
            for (var item of resp.data.data) {
              options.push({ label: item, value: item })
            }
            this.options = options
          } else {
            this.$message('获取失败')
          }
        })
        .catch((error) => {
          this.$message('获取发生错误=>' + error)
        })
    },
    // searchDataChange(searchData, currentFields) {
    //   if (this.fieldIndex == 0) {
    //     if (this.options.length <= 0 && !searchData[this.field]) {
    //       this.getFieldOptions(searchData)
    //     }
    //   }
    //   // else if (this.fieldIndex > 0) {
    //   //   var prevField = currentFields[index - 1]
    //   //   if (searchData[prevField]) {
    //   //     this.getFieldOptions(searchData)
    //   //   }
    //   // }

    //   // if (!searchData[this.field]) {
    //   //   this.getFieldOptions(searchData)
    //   // }
    // },
    valchange(val) {
      this.$emit('valchange', this.fieldIndex, val)
    },
    reset() {
      this.val = ''
      this.options = []
    },
  },
}
</script>
<style lang="less">
.product-select {
  width: 100px;
}
</style>